import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress, useTheme, useMediaQuery } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { planoAcaoService } from '../../services/PlanoAcaoService';
import AcaoPorArea from '../../types/negocio/AcaoPorArea';

interface AcoesPorAreaChartProps {
	data?: AcaoPorArea[];
	loading?: boolean;
}

// Cores para cada área no gráfico de pizza
const COLORS = ['#4e79a7', '#f28e2c', '#aaa', '#fdc36e', '#59a14f', '#e15759', '#76b7b2', '#edc949'];

const AcoesPorAreaChart: React.FC<AcoesPorAreaChartProps> = ({
	loading: initialLoading = false
}) => {
	const [data, setData] = useState<AcaoPorArea[]>([]);
	const [loading, setLoading] = useState(initialLoading);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const result = await planoAcaoService.buscarAcoesPorArea();
				setData(result);
			} catch (error) {
				console.error('Erro ao buscar dados de ações por área:', error);
				setData([]);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	if (loading) {
		return (
			<Card elevation={0}>
				<CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
					<CircularProgress />
				</CardContent>
			</Card>
		);
	}

	if (data.length === 0) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '220px' }}>
				<Typography variant="body1" color="text.secondary">
					Nenhum dado disponível
				</Typography>
			</Box>
		);
	}

	return (
		<Box sx={{
			height: 200,
			width: '100%',
			marginTop: 2
		}}>
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={data}
						cx="50%"
						cy="50%"
						labelLine={false}
						fill="#8884d8"
						dataKey="quantidade"
						nameKey="area"
						label={false}
					>
						{data.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
						))}
					</Pie>
					<Tooltip
						formatter={(value, name) => [`${value} ações`, name]}
						labelFormatter={() => ''}
					/>
					<Legend
						iconType="circle"
						wrapperStyle={{ fontSize: '12px', paddingLeft: '15px' }}
						formatter={(value) => value}
					/>
				</PieChart>
			</ResponsiveContainer>
		</Box>
	);
};

export default AcoesPorAreaChart;
